import axios from "axios";
import ErrorParser from './error.parser';

const Request = async (payload) => {
    try {
        const response = await axios(payload);
        return response.data;
    } 
    catch (error) {
        const message = ErrorParser.asMessage(error);
        throw new Error(message);
    }    
};

export default Request;